import React, { useEffect } from "react";
import FormTemplateListItem from "./FormTemplateListItem/FormTemplateListItem";
import { Accordion, ThemeProvider, Theme } from "@aws-amplify/ui-react";
import { sortByAlphaNumericalArray } from "utils/sort";
import { Colors } from "@factorearth/component-library";
import { FormTemplate, User } from "db/definitions";

interface Props {
	color: Colors;
	handleDeleteTemplate: (id: string) => Promise<boolean>;
	handleEditTemplate: (data: { id: string }) => Promise<void>;
	online: boolean;
	setupNewVersionDerived: (id: string, versionData: { versionName: string; publish: boolean }) => Promise<void>;
	templates: Record<string, FormTemplate[]>;
	userDoc: User;
}

function FormTemplateList(props: Props) {
	const { color, handleDeleteTemplate, handleEditTemplate, online, setupNewVersionDerived, templates, userDoc } = props;

	const [formTemplateList, setFormTemplateList] = React.useState(<></>);

	const theme: Theme = {
		name: "template-accordion-theme",
		tokens: {
			components: {
				accordion: {
					backgroundColor: { value: color.background.primary },
					item: {
						borderStyle: { value: "none" },
						borderRadius: { value: "0px" },
						trigger: {
							_focus: {
								borderColor: { value: "transparent" },
								boxShadow: { value: "none" },
							},
						},
						content: {
							paddingInline: { value: "0px" },
							paddingBlockEnd: { value: "0px" },
							paddingBlockStart: { value: "0px" },
						},
						icon: {
							color: { value: color.text.primary },
						},
					},
				},
			},
		},
	};

	useEffect(() => {
		function renderTemplateList() {
			let final = [];
			const templateGroups = sortByAlphaNumericalArray({ array: Object.keys(templates) });
			const first = 0;
			const last = templateGroups.length;
			for (let j = 0; j < templateGroups.length; j++) {
				const templateGroupKey = templateGroups[j];
				const templateGroupData = sortByAlphaNumericalArray({ array: templates[templateGroupKey], key: "template" });
				const groupFinal = [];
				for (let i = 0; i < templateGroupData.length; i++) {
					const template = templateGroupData[i];
					const html = (
						<FormTemplateListItem
							template={template}
							handleEditTemplate={handleEditTemplate}
							handleDeleteTemplate={handleDeleteTemplate}
							setupNewVersionDerived={setupNewVersionDerived}
							color={color}
							key={template.id}
							userDoc={userDoc}
							online={online}
						/>
					);
					groupFinal.push(html);
				}

				const groupHtml = (
					<Accordion.Container
						style={{
							borderBottom: `1px solid ${color.border.primary}`,
							borderTop: j === first || j === last ? `1px solid ${color.border.primary}` : "none",
							width: "100%",
						}}
						key={`template-list-${templateGroupKey}`}>
						<Accordion.Item value="template-key" style={{ color: color.text.primary }} data-test={`expand-form-template-group-${templateGroupKey}`}>
							<Accordion.Trigger style={{ height: "40px" }}>
								<div style={{ fontWeight: "700" }}>{templateGroupKey}</div>
								<div style={{ display: "flex", justifyContent: "space-between", fontWeight: "600", gap: "10px" }}>
									<div
										style={{
											display: "flex",
											background: color.background.tertiary,
											color: color.text.badge,
											borderRadius: "32px",
											width: "12px",
											height: "8px",
											justifyContent: "center",
											alignItems: "center",
											padding: "8px",
										}}>
										{templateGroupData.length}
									</div>
									<Accordion.Icon style={{ display: "flex" }} />
								</div>
							</Accordion.Trigger>
							<Accordion.Content style={{ background: color.background.tertiary }}>{groupFinal}</Accordion.Content>
						</Accordion.Item>
					</Accordion.Container>
				);
				final.push(groupHtml);
			}

			return (
				<ThemeProvider theme={theme} colorMode={color.theme}>
					{final}
				</ThemeProvider>
			);
		}
		setFormTemplateList(renderTemplateList());
	}, [templates]);

	return <>{formTemplateList}</>;
}

export default FormTemplateList;
